export enum Entitlements {
  Premium = 'premium',
}
